import { createGlobalStyle, css } from 'styled-components';

import { calculateFontSize, FontSize } from './utils';

export default createGlobalStyle(
  ({
    theme: {
      base: {
        scale,
        'font-size': baseFontSize,
        'font-scale': baseFontScale,
        'font-family': fontFamily,
        'custom-scrollbar': customScrollbar,
        'border-radius': borderRadius,
        palette: {
          'foreground-color': foregroundColor,
          'scrollbar-track': scrollbarTrack,
          'scrollbar-thumb': scrollbarThumb,
          'scrollbar-thumb-hover': scrollbarThumbHover
        },
        'line-height': lineHeight
      },
      components: { text }
    }
  }) => {
    // Can't call a hook here
    const fontSize = calculateFontSize(baseFontSize, baseFontScale);

    return css`
      *,
      *::before,
      *::after {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }

      ${customScrollbar &&
      css`
        * {
          scrollbar-color: ${scrollbarThumb} ${scrollbarTrack};
          scrollbar-width: thin;
        }

        @supports not ((scrollbar-width: thin) or (scrollbar-color: black white)) {
          /* stylelint-disable unit-allowed-list */

          *::-webkit-scrollbar {
            width: 12px;
            height: 12px;
          }

          *::-webkit-scrollbar-track {
            background-color: ${scrollbarTrack};
          }

          *::-webkit-scrollbar-corner {
            background-color: ${scrollbarTrack};
            border-bottom-right-radius: inherit;
          }

          *::-webkit-scrollbar-thumb {
            background-color: transparent;
            border: 3px solid transparent;
            border-radius: calc(1.125 * ${borderRadius});
            box-shadow: inset 0 0 2px 4px ${scrollbarThumb};
          }

          *::-webkit-scrollbar-thumb:hover {
            box-shadow: inset 0 0 2px 4px ${scrollbarThumbHover};
          }

          *::-webkit-scrollbar-track:horizontal {
            border-bottom-left-radius: inherit;
          }

          *::-webkit-scrollbar-track:vertical {
            border-top-right-radius: inherit;
          }

          /* stylelint-disable-next-line selector-pseudo-class-no-unknown */
          *::-webkit-scrollbar-track:not(:corner-present) {
            border-bottom-right-radius: inherit;
          }

          /* stylelint-enable unit-allowed-list */
        }
      `}

      html,
      :host {
        height: 100%;
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        font-size: calc(${scale} * 1rem);
      }

      body,
      :host {
        min-height: 100%;
        margin: 0;
        padding: 0;
        font-size: ${fontSize[text.primary['font-size'] as FontSize]};
        font-family: ${fontFamily};
        color: ${foregroundColor};
        line-height: ${lineHeight};
      }

      input,
      button,
      select,
      optgroup,
      textarea {
        margin: 0;
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
      }
    `;
  }
);
